import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

/**
 * Visual access to the reservation cart.
 * Reservation synchronization is intentionally deferred to the reservations phase.
 */
@Component({
  selector: 'app-checkout-popover',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './checkout-popover.component.html',
  styleUrl: './checkout-popover.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckoutPopoverComponent {}
